/*
 * @Author: 张怀宇
 * @Date: 2020-04-07 13:45:56
 * @LastEditors: 张怀宇
 * @LastEditTime: 2020-05-06 08:45:45
 */
/**
 * 柜子类
 */
export class Cabinet {
  items_list: Array<CabinetItem>;
  hard_number: string;
  mode: string;
  type_id: string | number;
  type_name: string;
  line_id: string | number;
  line: string;
  point_id: string | number;
  point_name: string;
  template_name: string;
  replace_flag: boolean;
  created_at: string;
  group_id: string | number;
  group_name: string;
  by_piece: string;
  pay_mode: string | number;
  constructor(data?: Cabinet) {
    console.log(data);
    this.items_list = data ? data.items_list : [];
    this.hard_number = data ? data.hard_number : "";
    this.mode = data ? data.mode : "";
    this.type_id = data ? data.type_id : "";
    this.type_name = data ? data.type_name : "";
    this.line_id = data ? data.line_id : "";
    this.line = data ? data.line : "";
    this.point_id = data ? data.point_id : "";
    this.point_name = data ? data.point_name : "";
    this.template_name = data ? data.template_name : "";
    this.replace_flag = data ? data.replace_flag : true;
    this.created_at = data ? data.created_at : "";
    this.group_id = data ? data.group_id : "";
    this.group_name = data ? data.group_name : "";
    this.by_piece = data ? data.by_piece : "";
    // this.pay_mode = data ? data.pay_mode === 3 ? "3" : data.pay_mode === 2 ? "2" : "1" : "";
    this.pay_mode = data ? data.pay_mode : "";
  }
}
/**
 * 柜子商品类
 */
export class CabinetItem {
  category_name: string;
  column: number;
  cost_price: number;
  goods_lane: string;
  id: number | string;
  image_url: string;
  item_id: string | number;
  item_name: string;
  item_number: string | number;
  max_weight: number;
  min_weight: number;
  qty: number;
  real_price: number;
  rows: number;
  warn_qty: number;
  view_id: number | string;
  view_image: number | string;
  sellstatus: string;

  //前端专用属性
  max_qty: number;
  qty_error: string;
  warn_qty_error: string;
  price_error: string;
  constructor(row: number, col: number, data?: CabinetItem) {
    this.category_name = data ? data.category_name : "";
    this.column = col;
    this.cost_price = data ? data.cost_price : 0;
    this.goods_lane =
      row && col ? row + "-" + col : data ? data.goods_lane : "";
    this.id = data ? data.id : "";
    this.image_url = data ? data.image_url : "";
    this.item_id = data ? data.item_id : "";
    this.item_name = data ? data.item_name : "";
    this.item_number = data ? data.item_number : "";
    this.max_weight = data ? data.max_weight : 0;
    this.min_weight = data ? data.min_weight : 0;
    this.qty = data ? data.qty : 5;
    this.max_qty = 100;
    this.real_price = data ? data.real_price : 0;
    this.rows = row;
    this.warn_qty = data ? Math.ceil(data.warn_qty * 0.4) : 2;
    this.sellstatus = data ? data.sellstatus : "NORMAL";
    this.qty_error = "";
    this.warn_qty_error = "";
    this.price_error = "";
    this.view_id = data ? data.view_id : "";
    this.view_image = data ? data.view_image : "";
  }
}
